import { useEffect, useState, useRef } from 'react';
import react from 'react';
import './home.css';
import { PiRabbitBold } from 'react-icons/pi';
import { FaArrowDown } from 'react-icons/fa';

const Home = () => {
  const [choHeight, setChoHeight] = useState(200);
  const [isMobile, setIsMobile] = useState(false);
  const divHeightRef = useRef(null);

  useEffect(() => {
    const checkIfMobile = () => {
      const userAgentCheck = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
      const viewportCheck = window.innerWidth <= 768;
      return userAgentCheck || viewportCheck;
    };

    const handleResize = () => {
      setIsMobile(checkIfMobile());
      if (divHeightRef.current && !checkIfMobile()) {
        const divHeight = divHeightRef.current.offsetHeight;
        setChoHeight(divHeight);
      }
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="home-main">
      <div className="home-section1">
        <h1>O NÁS...</h1>
        <div className="home-section1-content1">
          <div className="home-section1-content1-left">
            <h3>KTO SME?</h3>
            <PiRabbitBold className="home-section1-content1-left-rabbit1" />
            <PiRabbitBold className="home-section1-content1-left-rabbit2" />
            <p>
              Sme nezisková organizácia Zachráň zajka, ktorá sa špecializuje na
              záchranu a dočasné umiestnenie zajkov v núdzi a hľadá pre nich
              nové domovy.<br></br>
              <br></br>Sme tu preto, aby sme pomohli týmto zvieratkám a poskytli
              im druhú šancu na šťastný a bezpečný život
            </p>
          </div>
          <div className="home-section1-content1-right">
            <img src="./images/zajac1.png" />
          </div>
        </div>
        <div className="home-section1-divider">
          <div className="home-divider-left"></div>
          <div className="home-divider-dot"></div>
          <div className="home-divider-image">
            <img src="./images/carrot.png" />
          </div>
          <div className="home-divider-dot"></div>
          <div className="home-divider-right"></div>
        </div>
        <div className="home-section1-content2">
          <div
            className="home-section1-content2-left"
            style={!isMobile ? { height: `${choHeight}px` } : { height: 'auto' }}
          >
            <div className="cho2">
              <img src="./images/cho2.jpeg" />
            </div>
            <div className="cho13">
              <img src="./images/cho1.jpeg" />
              <img src="./images/cho3.jpeg" />
            </div>
          </div>
          <div className="home-section1-content2-right" ref={divHeightRef}>
            <h3>AKO TO ZAČALO?</h3>
            <PiRabbitBold className="home-section1-content1-left-rabbit1" />
            <PiRabbitBold className="home-section1-content1-left-rabbit2" />
            <p>
              Všetko to začalo záchranením Chocholúšika. Bol zachránený od
              nezodpovedných, ziskuchtivých majiteľov z nevhodných životných
              podmienok a v zlom zdravotnom stave.<br></br>
              <br></br>Po jeho preliečení a zaistení mu láskyplného domova bolo
              rozhodnuté: <br></br>
              <br></br>
              <span>BUDEME POMÁHAŤ VŠETKÝM ZAJKOM, KTORÍ POMOC POTREBUJÚ</span>
            </p>
          </div>
        </div>
      </div>
      <div className="home-section2">
        <div className="home-section2-save1">
          <div className="sb">
            <img src="./images/s1b.jpeg" className="home-section2-save-img" />
          </div>
          <div className="sa">
            <img src="./images/s1a.jpeg" className="home-section2-save-img" />
          </div>
          <div className="arrow">
            <img
              src="./images/arrow.png"
              className="home-section2-save-arrow"
            />
          </div>
          <div className="name">
            <p>CAPPUCCINO</p>
          </div>
        </div>
        <div className="home-section2-save2">
          <div className="sb">
            <img src="./images/s2b.jpeg" className="home-section2-save-img" />
          </div>
          <div className="sa">
            <img src="./images/s2a.jpeg" className="home-section2-save-img" />
          </div>
          <div className="arrow">
            <img
              src="./images/arrow.png"
              className="home-section2-save-arrow"
            />
          </div>
          <div className="name">
            <p>LINDT</p>
          </div>
        </div>
        <div className="home-section2-save3">
          <div className="sb">
            <img src="./images/s3b.jpeg" className="home-section2-save-img" />
          </div>
          <div className="sa">
            <img src="./images/s3a.jpeg" className="home-section2-save-img" />
          </div>
          <div className="arrow">
            <img
              src="./images/arrow.png"
              className="home-section2-save-arrow"
            />
          </div>
          <div className="name">
            <p>MIŠKO</p>
          </div>
        </div>
        <div className="home-section2-save4">
          <div className="sb">
            <img src="./images/s4b.jpeg" className="home-section2-save-img" />
          </div>
          <div className="sa">
            <img src="./images/s4a.jpeg" className="home-section2-save-img" />
          </div>
          <div className="arrow">
            <img
              src="./images/arrow.png"
              className="home-section2-save-arrow"
            />
          </div>
          <div className="name">
            <p>CHOCHOLUŠIK</p>
          </div>
        </div>
      </div>
      <div className="home-section2-mobile">
        <div className="home-section2-save1-mobile">
          <div className="name-mobile">
            <p style={{ fontSize: '0.7rem', marginBottom: '1vh', fontWeight: 'bold' }}>CAPPUCCINO</p>
          </div>
          <div className="sb-mobile">
            <img src="./images/s1b.jpeg" className="home-section2-save-img-mobile" />
          </div>
          <div className="arrow-mobile">
            <FaArrowDown />
          </div>
          <div className="sa-mobile">
            <img src="./images/s1a.jpeg" className="home-section2-save-img-mobile" />
          </div>
        </div>
        <div className="home-section2-save2-mobile">
          <div className="name-mobile">
            <p style={{ fontSize: '0.7rem', marginBottom: '1vh', fontWeight: 'bold' }}>LINDT</p>
          </div>
          <div className="sb-mobile">
            <img src="./images/s2b.jpeg" className="home-section2-save-img-mobile" />
          </div>
          <div className="arrow-mobile">
            <FaArrowDown />
          </div>
          <div className="sa-mobile">
            <img src="./images/s2a.jpeg" className="home-section2-save-img-mobile" />
          </div>
        </div>
        <div className="home-section2-save3-mobile">
          <div className="name-mobile">
            <p style={{ fontSize: '0.7rem', marginBottom: '1vh', fontWeight: 'bold' }}>MIŠKO</p>
          </div>
          <div className="sb-mobile">
            <img src="./images/s3b.jpeg" className="home-section2-save-img-mobile" />
          </div>
          <div className="arrow-mobile">
            <FaArrowDown />
          </div>
          <div className="sa-mobile">
            <img src="./images/s3a.jpeg" className="home-section2-save-img-mobile" />
          </div>
        </div>
        <div className="home-section2-save4-mobile">
          <p style={{ fontSize: '0.7rem', marginBottom: '1vh', fontWeight: 'bold' }}>CHOCHOLUŠIK</p>
          <div className="sb-mobile">
            <img src="./images/s4b.jpeg" className="home-section2-save-img-mobile" />
          </div>
          <div className="arrow-mobile">
            <FaArrowDown />
          </div>
          <div className="sa-mobile">
            <img src="./images/s4a.jpeg" className="home-section2-save-img-mobile" />
          </div>
        </div>
      </div>
      <div className="home-section3">
        <h1>NAŠE CIELE</h1>
        <div className="home-section3-roadmap">
          <div className="roadmap-hrl"></div>
          <div className="roadmap-bubbless-container">
            <div className="roadmap-bubble b1">
              <div className="text-bubble1">
                <p>Zriadiť záchranné centrá po celom Slovensku</p>
              </div>
              <div className="bubble1">
                <img src="./images/1.png" />
              </div>
              <div className="roadmap-bubble-hrl hrl1"></div>
            </div>
            <div className="roadmap-bubble b2">
              <div className="roadmap-bubble-hrl hrl2"></div>
              <div className="bubble2">
                <img src="./images/2.png" />
              </div>
              <div className="text-bubble2">
                <p>
                  Poskytovanie veterinárnej starostlivosti a prvej pomoci
                  zachráneným zajkom
                </p>
              </div>
            </div>
            <div className="roadmap-bubble b3">
              <div className="text-bubble3">
                <p>
                  Edukácia a osveta o zodpovednom chove králikov pre širokú
                  verejnosť
                </p>
              </div>
              <div className="bubble3">
                <img src="./images/3.png" />
              </div>
              <div className="roadmap-bubble-hrl hrl3"></div>
            </div>
            <div className="roadmap-bubble b4">
              <div className="roadmap-bubble-hrl hrl4"></div>
              <div className="bubble4">
                <img src="./images/4.png" />
              </div>
              <div className="text-bubble4">
                <p>Podpora adopcie zachránených zajkov</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="home-section3-mobile">
        <h1>NAŠE CIELE</h1>
        <div className="home-section3-roadmap-mobile">

          <div className="bubble1-mobile">
            <img src="./images/1.png" />
          </div>
          <div className="roadmap-bubble-mobile b1-mobile">
            <div className="text-bubble1-mobile">
              <p>Zriadiť záchranné centrá po celom Slovensku</p>
            </div>
          </div>

          <div className="roadmap-bubble-vrl-mobile"></div>

          <div className="bubble1-mobile">
            <img src="./images/2.png" />
          </div>
          <div className="roadmap-bubble-mobile b1-mobile">
            <div className="text-bubble1-mobile">
              <p>Poskytovanie veterinárnej starostlivosti a prvej pomoci
                zachráneným zajkom</p>
            </div>
          </div>

          <div className="roadmap-bubble-vrl-mobile"></div>

          <div className="bubble1-mobile">
            <img src="./images/3.png" />
          </div>
          <div className="roadmap-bubble-mobile b1-mobile">
            <div className="text-bubble1-mobile">
              <p>Edukácia a osveta o zodpovednom chove králikov pre širokú
                verejnosť</p>
            </div>
          </div>

          <div className="roadmap-bubble-vrl-mobile"></div>

          <div className="bubble1-mobile">
            <img src="./images/4.png" />
          </div>
          <div className="roadmap-bubble-mobile b1-mobile">
            <div className="text-bubble1-mobile">
              <p>Podpora adopcie zachránených zajkov</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
